<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Solicitações de cancelamento de garantia</h5>
<div class="container" *ngIf="valoresPesquisaForm; else carregando">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/cancelamento/cadastro']" placement="bottom"
          ngbTooltip="Enviar nova solicitação de cancelamento de garantia" [disabled]="!podeEnviarSolicitacaoCancelamento"><i class="fa fa-file-signature">
          </i> Solicitar cancelamento</button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
        [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select  id="agenteFinanceiro" class="form-select " [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of agentesFinanceiros"
                  [ngValue]="item">{{ item.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioInicio">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicio" idInput="dataEnvioInicio" formControlName="dataEnvioInicio" >
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
          <label class="form-label" for="dataEnvioFim">Data de envio final:</label>
          <bn-datepicker name="dataEnvioFim" idInput="dataEnvioFim" formControlName="dataEnvioFim">
          </bn-datepicker>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="idSolicitacaoCancelamento">Id.: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="O identificador da solicitação de cancelamento enviada"></i></label>
        <input type="text" class="form-control" formControlName="idSolicitacaoCancelamento">
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select id="sistema" class="form-select" [compareWith]="compararPorId" formControlName="sistema">
          <option [ngValue]=null>Todos</option>
          <option [ngValue]="'CL'">Crédito Livre</option>
          <option [ngValue]="'15'">15 - Contratos FINAME</option>
          <option [ngValue]="'89'">89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input class="form-control" formControlName="idExternoOperacao">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input class="form-control" formControlName="contrato">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label" for="estado">Estado:</label>
        <select id="estado" class="form-select" [compareWith]="compararPorId" formControlName="estado">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of estados"
                  [ngValue]="item">{{item.nomeEstado }}</option>
        </select>
      </div>

    </div>
  </form>
</div>

<app-cancelamento-listagem
  [solicitacoesCancelamento]="solicitacoesCancelamento"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  (aoExportarSolicitacoesCancelamento)="exportarSolicitacoesCancelamento($event)"
  [hidden]="!pesquisado"
  (aoMudarPagina)="mudancaPagina($event)"
  >
</app-cancelamento-listagem>